<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperHumanResourcesIrregularStaffRequest',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'HumanResourcesModule',
    };
  },
};
</script>
